import { render, staticRenderFns } from "./ComponentTree.vue?vue&type=template&id=0b1d9be8&"
import script from "./ComponentTree.vue?vue&type=script&lang=js&"
export * from "./ComponentTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports